<div class="bank-statement-verification-report">
  <!-- Page Control for export of data -->
  <PageControl
    :title="'Bank Statement Verification Report'"
    :elements_query="sheet_elements"
  >
    <button
      @click="show_export_modal"
      class="btn btn-bg-green text-xs rounded-small shadow-sm me-2"
    >
      <i class="bi bi-download"></i>
      Export Data
    </button>

    <!-- Export Modal -->
    <Teleport to="body">
      <div
        class="modal fade"
        :id="'export-modal-' + report_reference"
        tabindex="-1"
        aria-labelledby="exportModalLabel"
        aria-hidden="true"
      >
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content rounded-4 shadow">
          <div class="modal-header">
            <h6 class="modal-title fw-semibold text-muted">
              Export Bank Statement Verification Report Data
            </h6>
          </div>
          <div class="modal-body">
            <div class="mb-3">
              <label class="form-label fw-bold">Select Data to Export:</label>
              <div class="form-check">
                <input
                  class="form-check-input"
                  type="checkbox"
                  v-model="export_options.account_information"
                  id="accountInformation"
                />
                <label class="form-check-label" for="accountInformation">
                  Account Information & Holder Details
                </label>
              </div>
              <div class="form-check">
                <input
                  class="form-check-input"
                  type="checkbox"
                  v-model="export_options.transaction_analysis"
                  id="transactionAnalysis"
                />
                <label class="form-check-label" for="transactionAnalysis">
                  Financial Summary & Analysis
                </label>
              </div>
              <div class="form-check">
                <input
                  class="form-check-input"
                  type="checkbox"
                  v-model="export_options.monthly_breakdown"
                  id="monthlyBreakdown"
                />
                <label class="form-check-label" for="monthlyBreakdown">
                  Monthly Income/Expense Breakdown
                </label>
              </div>
              <div class="form-check">
                <input
                  class="form-check-input"
                  type="checkbox"
                  v-model="export_options.category_analysis"
                  id="categoryAnalysis"
                />
                <label class="form-check-label" for="categoryAnalysis">
                  Transaction Category Analysis
                </label>
              </div>
              <div class="form-check">
                <input
                  class="form-check-input"
                  type="checkbox"
                  v-model="export_options.transaction_history"
                  id="transactionHistory"
                />
                <label class="form-check-label" for="transactionHistory">
                  Complete Transaction History
                </label>
              </div>
              <div class="form-check" v-if="export_format === 'json'">
                <input
                  class="form-check-input"
                  type="checkbox"
                  v-model="export_options.raw_json"
                  id="rawJson"
                />
                <label class="form-check-label" for="rawJson">
                  Raw JSON Response Data
                </label>
              </div>
            </div>
            <div class="mb-3">
              <label class="form-label fw-bold">Export Format:</label>
              <select class="form-select" v-model="export_format">
                <option value="csv">
                  CSV (Separate files for each section)
                </option>
                <option value="excel">
                  Excel (Single file with multiple sheets)
                </option>
                <option value="json">JSON (Complete data structure)</option>
              </select>
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-bg-secondary text-xs rounded-small shadow-sm me-2"
              @click="hide_export_modal"
            >
              Cancel
            </button>
            <button
              type="button"
              class="btn btn-bg-green text-xs rounded-small shadow-sm"
              @click="export_data"
              :disabled="!has_export_options_selected"
            >
              Export Data
            </button>
          </div>
        </div>
      </div>
    </div>
    </Teleport>
  </PageControl>
  <PageComponent>
    <!-- Page 1: Report Header & Account Information -->
    <SectionSheet>
      <div
        class="container-fluid py-3 header d-flex align-items-center justify-content-between border-bottom mb-3"
      >
        <div class="d-flex">
          <img
            class="logo"
            width="295"
            height="125"
            src="@/assets/images/new_black_logo2.svg"
            alt="Logo"
          />
        </div>
        <div class="d-flex text-end">
          <div>
            <div class="h4 fw-bold mb-1">Detailed Wallet Analysis</div>
            <div class="text-muted text-xs">
              28 Fricker Rd,<br />
              Illovo, Johannesburg,<br />
              2196 South Africa<br />
              Website:
              <a
                href="https://www.goodpeopledata.com/"
                target="_blank"
                class="text-decoration-none text-muted"
                >www.goodpeopledata.com</a
              >
            </div>
          </div>
        </div>
      </div>

      <!-- Verification Summary -->
      <div class="card shadow-sm border bg-white mb-3">
        <div class="card-header">
          <h6 class="mb-0">
            <i class="bi bi-check-circle-fill me-2"></i>
            Affordability Wallet
          </h6>
          <p>

          </p>
        </div>
        <div class="card-body text-xs">
        <p>
          The Applicant's financial transactions and credit information have been analysed with an affordability analysis detailed below. This bank statement has been successfully verified and analyzed. The report contains
          <span class="fw-bold text-dark">{{ total_transactions }}</span>
          transactions spanning
          <span class="fw-bold text-dark">{{ statement_period_days }}</span>
          days ({{ formatted_statement_period }}). The account shows a net cash flow of
          <span class="fw-bold text-dark">{{ net_flow >= 0 ? 'positive' : 'negative' }}</span>
          R <span class="fw-bold text-dark">{{ formatted_net_flow }}</span>.
        </p>

          <div class="row g-2">
            <div class="col-md-6">
              <div class="status-card-simple">
                <div class="status-icon-simple">
                  <i class="bi bi-arrow-down-circle"></i>
                </div>
                <div class="status-content-simple">
                  <div class="status-label-simple">Credit Transactions</div>
                  <div class="status-value-simple bg-white">
                    <span class="fw-bold">{{ total_credit_transactions }}</span>
                    totaling
                    <span class="fw-bold">R {{ formatted_total_credits }}</span>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="status-card-simple">
                <div class="status-icon-simple">
                  <i class="bi bi-arrow-up-circle"></i>
                </div>
                <div class="status-content-simple">
                  <div class="status-label-simple">Debit Transactions</div>
                  <div class="status-value-simple bg-white">
                    <span class="fw-bold">{{ total_debit_transactions }}</span>
                    totaling
                    <span class="fw-bold">R {{ formatted_total_debits }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Financial Summary Cards -->
      <div class="row g-2 mb-2">
        <div class="col-md-6">
          <div class="summary-card credits shadow-sm border bg-white">
            <div class="summary-icon">
              <i class="bi bi-arrow-down-circle"></i>
            </div>
            <div class="summary-content">
              <div class="summary-label">Total Credits</div>
              <div class="summary-value">R {{ formatted_total_credits }}</div>
              <div class="summary-detail">
                {{ total_credit_transactions }} transactions
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-6">
          <div class="summary-card debits shadow-sm border bg-white">
            <div class="summary-icon">
              <i class="bi bi-arrow-up-circle"></i>
            </div>
            <div class="summary-content">
              <div class="summary-label">Total Debits</div>
              <div class="summary-value">R {{ formatted_total_debits }}</div>
              <div class="summary-detail">
                {{ total_debit_transactions }} transactions
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-6">
          <div class="summary-card shadow-sm border bg-white net-flow">
            <div class="summary-icon">
              <i class="bi bi-graph-up"></i>
            </div>
            <div class="summary-content">
              <div class="summary-label">Net Cash Flow</div>
              <div class="summary-value">R {{ formatted_net_flow }}</div>
              <div class="summary-detail">
                {{ net_flow >= 0 ? 'Positive' : 'Negative' }}
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-6">
          <div class="summary-card shadow-sm border bg-white avg-balance">
            <div class="summary-icon">
              <i class="bi bi-calculator"></i>
            </div>
            <div class="summary-content">
              <div class="summary-label">Average Balance</div>
              <div class="summary-value">R {{ formatted_average_balance }}</div>
              <div class="summary-detail">
                Over {{ statement_period_days }} days
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Account Overview -->
      <div class="row g-2 mb-2">
        <div class="col-md-6">
          <div class="info-card shadow-sm border bg-white">
            <h6 class="card-title">Report Information</h6>
            <div class="info-grid">
              <div class="info-item">
                <span class="label">Report Reference:</span>
                <span class="value">{{ report_reference }}</span>
              </div>
              <div class="info-item">
                <span class="label">Generated Date:</span>
                <span class="value">{{ generated_date }}</span>
              </div>
              <div class="info-item">
                <span class="label">Statement Period:</span>
                <span class="value">{{ formatted_statement_period }}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-6">
          <div class="info-card shadow-sm border bg-white">
            <h6 class="card-title">Account Details</h6>
            <div class="info-grid">
              <div class="info-item">
                <span class="label">Account Number:</span>
                <span class="value">{{ account_number }}</span>
              </div>
              <div class="info-item">
                <span class="label">Account Holder:</span>
                <span class="value">{{ account_holder }}</span>
              </div>
              <div class="info-item">
                <span class="label">Last Transaction Balance:</span>
                <span class="value balance-amount"
                  >R {{ formatted_account_balance }}</span
                >
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- Report Footer -->
      <div class="report-footer">
        <span
          >Generated: {{ generated_date }} | Reference: {{ report_reference
          }}</span
        >
        <span>Page 1 of {{ 4 + paginated_recent_transactions.length }}</span>
      </div>
    </SectionSheet>

    <!-- Page 2: Transaction Categories & Recent Transactions -->
    <SectionSheet>
      <!-- Activity Analysis -->
      <div class="row g-2 mb-2">
        <div class="col-md-6">
          <div class="info-card shadow-sm border bg-white">
            <h6 class="card-title">Activity Summary</h6>
            <div class="info-grid">
              <div class="info-item">
                <span class="label">Total Transactions:</span>
                <span class="value">{{ total_transactions }}</span>
              </div>
              <div class="info-item">
                <span class="label">Days with Activity:</span>
                <span class="value">{{ active_transaction_days }}</span>
              </div>
              <div class="info-item">
                <span class="label">Average Daily Transactions:</span>
                <span class="value">{{ average_daily_transactions }}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-6">
          <div class="info-card shadow-sm border bg-white">
            <h6 class="card-title">Additional Account Information</h6>
            <div class="info-grid">
              <div class="info-item">
                <span class="label">Account Type:</span>
                <span class="value">{{ account_name }}</span>
              </div>
              <div class="info-item">
                <span class="label">Overdraft Limit:</span>
                <span class="value">{{ overdraft_limit }}</span>
              </div>
              <div class="info-item">
                <span class="label">Account Address:</span>
                <span class="value"
                  ><address>{{ account_address }}</address></span
                >
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- All Transaction Categories -->
      <div class="row mb-3" v-if="transaction_categories.length > 6">
        <div class="col-12">
          <div class="info-card">
            <h6 class="card-title">All Transaction Categories</h6>
            <div class="row">
              <div
                class="col-md-4"
                v-for="category in transaction_categories"
                :key="category.slug"
              >
                <div class="category-summary">
                  <div class="category-header">
                    <i :class="get_category_icon(category.slug)"></i>
                    <span class="category-name">{{ category.name }}</span>
                  </div>
                  <div class="category-details">
                    <div class="detail-row">
                      <span class="detail-label">Transactions:</span>
                      <span class="detail-value">{{ category.count }}</span>
                    </div>
                    <div class="detail-row">
                      <span class="detail-label">Credits:</span>
                      <span class="detail-value"
                        >R {{ format_currency(category.total_credits) }}</span
                      >
                    </div>
                    <div class="detail-row">
                      <span class="detail-label">Debits:</span>
                      <span class="detail-value"
                        >R {{ format_currency(category.total_debits) }}</span
                      >
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Balance Analysis -->
      <div class="card shadow-sm border bg-white mb-3">
        <div class="card-header">
          <h6 class="mb-0">
            <i class="bi bi-bar-chart-line-fill text-primary me-2"></i>
            Balance Analysis
          </h6>
        </div>
        <div class="card-body text-xs">
          <div class="row g-2">
            <div class="col-md-6">
              <div class="status-card-simple">
                <div class="status-icon-simple">
                  <i class="bi bi-box-arrow-in-right"></i>
                </div>
                <div class="status-content-simple">
                  <div class="status-label-simple">Opening Balance</div>
                  <div class="status-value-simple bg-white">
                    <span class="fw-bold"
                      >R {{ formatted_opening_balance }}</span
                    >
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="status-card-simple">
                <div class="status-icon-simple">
                  <i class="bi bi-box-arrow-left"></i>
                </div>
                <div class="status-content-simple">
                  <div class="status-label-simple">Closing Balance</div>
                  <div class="status-value-simple bg-white">
                    <span class="fw-bold"
                      >R {{ formatted_closing_balance }}</span
                    >
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="status-card-simple">
                <div class="status-icon-simple">
                  <i class="bi bi-graph-up-arrow"></i>
                </div>
                <div class="status-content-simple">
                  <div class="status-label-simple">Highest Balance</div>
                  <div class="status-value-simple bg-white">
                    <span class="fw-bold"
                      >R {{ formatted_highest_balance }}</span
                    >
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="status-card-simple">
                <div class="status-icon-simple">
                  <i class="bi bi-graph-down-arrow"></i>
                </div>
                <div class="status-content-simple">
                  <div class="status-label-simple">Lowest Balance</div>
                  <div class="status-value-simple bg-white">
                    <span class="fw-bold"
                      >R {{ formatted_lowest_balance }}</span
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="row mb-3">
        <div class="col-12">
          <div class="card shadow-sm border bg-white">
            <div class="card-header">
              <h6 class="mb-0">
                <i class="bi bi-bar-chart text-primary me-2"></i>Monthly Income
                vs Expenses
              </h6>
            </div>
            <div class="card-body">
              <div id="income-expenses-chart"></div>
            </div>
          </div>
        </div>
      </div>

      <!-- Report Footer -->
      <div class="report-footer">
        <span
          >Generated: {{ generated_date }} | Reference: {{ report_reference
          }}</span
        >
        <span>Page 2 of {{ 4 + paginated_recent_transactions.length }}</span>
      </div>
    </SectionSheet>

    <SectionSheet>
      <div class="row mb-3">
        <div class="col-12">
          <div class="card shadow-sm border bg-white">
            <div class="card-header">
              <h6 class="mb-0">
                <i class="bi bi-pie-chart text-primary me-2"></i>Transaction
                Categories
              </h6>
            </div>
            <div class="card-body">
              <div id="categories-chart"></div>
            </div>
          </div>
        </div>
      </div>

      <!-- Transaction Categories -->
      <div class="card shadow-sm border bg-white mb-3">
        <div class="card-header">
          <h6 class="mb-0">
            <i class="bi bi-pie-chart-fill text-primary me-2"></i>
            Transaction Analysis by Category
          </h6>
        </div>
        <div class="card-body text-xs">
          <div class="row g-2">
            <div
              class="col-md-6"
              v-for="category in transaction_categories.slice(0, 6)"
              :key="category.slug"
            >
              <div class="status-card-simple">
                <div class="status-icon-simple">
                  <i :class="get_category_icon(category.slug)"></i>
                </div>
                <div class="status-content-simple">
                  <div class="status-label-simple">{{ category.name }}</div>
                  <div class="status-value-simple bg-white">
                    <span class="fw-bold">{{ category.count }}</span>
                    transactions
                  </div>
                  <div class="status-detail-simple">
                    <small class="text-muted">
                      Credits: R {{ format_currency(category.total_credits) }}
                    </small>
                    <br />
                    <small class="text-muted">
                      Debits: R {{ format_currency(category.total_debits) }}
                    </small>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Report Footer -->
      <div class="report-footer">
        <span
          >Generated: {{ generated_date }} | Reference: {{ report_reference
          }}</span
        >
        <span>Page 3 of {{ 4 + paginated_recent_transactions.length }}</span>
      </div>
    </SectionSheet>

    <!-- Page 3: Complete Analysis -->
    <!-- Transactions Pagination: 25 per page, up to 200 (8 pages max) -->
    <template
      v-for="(page_transactions, page_index) in paginated_recent_transactions"
      :key="'transactions-page-' + (page_index + 1)"
    >
      <SectionSheet>
        <!-- Recent Transactions -->
        <div class="card shadow-sm border bg-white mb-3">
          <div class="card-header">
            <h6 class="mb-0">
              <i class="bi bi-clock-history text-info me-2"></i>
              Recent Transactions — Page {{ page_index + 1 }}
            </h6>
          </div>
          <div class="card-body text-xs">
            <div class="transaction-table">
              <table class="table">
                <thead>
                  <tr>
                    <th>Date</th>
                    <th>Description</th>
                    <th>Type</th>
                    <th>Amount</th>
                    <th>Balance</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="transaction in page_transactions"
                    :key="transaction.id"
                  >
                    <td class="date-cell">
                      {{ formatDate(transaction.date) }}
                    </td>
                    <td class="description-cell">
                      {{ transaction.description }}
                    </td>
                    <td class="type-cell">
                      <span
                        :class="transaction.type === 'credit' ? 'type-badge credit' : 'type-badge debit'"
                      >
                        {{ transaction.type.toUpperCase() }}
                      </span>
                    </td>
                    <td class="amount-cell">
                      R {{ format_currency(transaction.amount) }}
                    </td>
                    <td class="balance-cell">
                      R {{ format_currency(transaction.balance) }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <!-- Report Footer -->
        <div class="report-footer">
          <span>
            Generated: {{ generated_date }} | Reference: {{ report_reference }}
          </span>
          <span
            >Page {{ 4 + page_index }} of {{ 4 +
            paginated_recent_transactions.length }}</span
          >
        </div>
      </SectionSheet>
    </template>

    <!-- Disclaimer and Information Section -->
    <SectionSheet>
      <div class="card shadow-sm border bg-white mb-2">
        <div class="card-header bg-light">
          <h6 class="mb-0">Disclaimer and Information</h6>
        </div>
        <div class="card-body">
          <div class="disclaimer-content">
            <h6 class="mb-3 border-bottom pb-2">
              <i class="bi bi-info-circle me-2"></i>Statement Information
            </h6>
            <p class="text-xs mb-4">
              This Bank Statement Verification Report is generated from uploaded
              bank statements. The data presented reflects the information as
              retrieved on the date of report generation and has not been
              altered or changed in any way by The Good People Data Company.
            </p>

            <h6 class="mb-3 border-bottom pb-2">
              <i class="bi bi-shield-lock me-2"></i>Data Privacy
            </h6>
            <p class="text-xs mb-4">
              All personal information are processed in accordance with
              applicable data protection laws including POPIA (Protection of
              Personal Information Act). This report should only be shared with
              authorized personnel who require access to this information for
              legitimate business purposes.
            </p>

            <h6 class="mb-3 border-bottom pb-2">
              <i class="bi bi-gear me-2"></i>Technical Notes
            </h6>
            <p class="text-xs mb-4">
              All data is extracted using automated processing tools. The
              accuracy of the report depends on the quality and completeness of
              the uploaded bank statement. For any discrepancies or questions,
              please contact The Good People Data Company support team.
            </p>

            <div class="text-center text-muted mt-3">
              <p class="mb-0 text-xs">
                © {{ new Date().getFullYear() }} The Good People Data Company.
                All rights reserved.
              </p>
            </div>
          </div>
        </div>
      </div>
      <!-- Report Footer -->
      <div class="report-footer">
        <span
          >Generated: {{ generated_date }} | Reference: {{ report_reference
          }}</span
        >
        <span
          >Page {{ 4 + paginated_recent_transactions.length }} of {{ 4 +
          paginated_recent_transactions.length }}</span
        >
      </div>
    </SectionSheet>
  </PageComponent>
</div>
